<script setup>
import Button from "@/components/atoms/Button.vue";
import Price from "~/components/atoms/Price.vue";

const props = defineProps({
  heads: Array,
  rows: Array,
  skeleton: Boolean
})


const getWrapper = (item) => {
  if (item.url) return defineNuxtLink({})
  return 'div'
}
</script>

<template>
  <table class="full-width" :class="{skeleton:props.skeleton}">
    <caption>
      <header>
        <slot name="caption"/>
      </header>
    </caption>
    <thead>
    <tr>
      <th v-for="head in heads" :style="{textAlign:head.textAlign}">{{ head.title }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in rows">
      <td :style="{minWidth:cell.width, fontSize:cell.fontSize, textAlign:cell.textAlign}" v-for="cell in row">
        <component :to="'/shop/'+cell.url" :is="getWrapper(cell)">
          <template v-if="cell.type === 'image'">
            <img :class="cell.class" :src="cell.content"/>
          </template>
          <template v-else-if="cell.type==='button'">
            <Button :class="cell.class" @click="cell.callback(row)" :text="cell.content"/>
          </template>
          <template v-else-if="cell.type==='price'">
            <Price :price="cell.price"/>
            {{ cell.content }}
          </template>
          <template v-else>
            <template v-if="Array.isArray(cell.content)">
              <p :class="cell.class" v-for="item in cell.content"
                 v-html="item"></p>
            </template>
            <template v-else>
              <component v-if="cell.component" :is="cell.component"/>
              {{ cell.content }}
            </template>
          </template>
        </component>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<style scoped lang="scss">
table {
  border-spacing: 0;
}

th, td {
  height: 57px;
}

th {
  text-align: left;
  font-weight: 600;
}

td {
  border-top: 1px solid $border-grey;
}

table.skeleton {
  td {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 1px;
      left: 1px;
      right: 1px;
      bottom: 1px;
      background: $grey;
    }
  }
}
</style>
